// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".asset-preview .thumbnail[data-v-784a72f9]{height:302px;border-top-left-radius:unset;border-top-right-radius:unset}.asset-preview .thumbnail img[data-v-784a72f9]{max-height:300px}.fa-crown.gold[data-v-784a72f9]{color:#bf9000}", ""]);
// Exports
module.exports = exports;
